import React from "react";

import { twMerge } from "@/design-system/twMerge";

interface DividerProps {
  className?: string;
}

export function Divider({ className }: DividerProps) {
  return <hr className={twMerge("border-dividerDefault", className)} />;
}
